import { ReservationPreference } from '@dreryk/egabinet-waitlist-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigSingleSelection,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { RESERVATION_PREFERENCES } from '../../../shared/reservationPreference';
import { WaitlistFilterPanelSearchParam } from '../../WaitlistFilterPanel.types';

const RESERVATION_PREFERENCE_TO_SEARCH_PARAM: Record<ReservationPreference, number> = {
   PRACTITIONER: 0,
   LOCATION: 1,
   TIME: 2,
};

export const createReservationPreferenceTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenPreference: ReservationPreference) => string) => {
   return (chosenPreference) => {
      return translate(translationKeys.reservationPreferenceMapUppercase[chosenPreference]);
   };
};

export const reservationPreferenceCodec: FilterPanelControllerCodecConfigSingleSelection<ReservationPreference> = {
   type: 'single-selection',
   keyGenerator: (preference) => (preference ? RESERVATION_PREFERENCE_TO_SEARCH_PARAM[preference] : undefined),
   items: RESERVATION_PREFERENCES,
};

export const reservationPreferenceDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   ReservationPreference,
   WaitlistFilterPanelSearchParam.RESERVATION_PREFERENCE
> = (currentReservationPreference) => {
   return [
      {
         targetValue: null,
         label: translationKeys.reservationPreferenceMapUppercase[currentReservationPreference],
         testId: `reservationPreference-${currentReservationPreference}`,
      },
   ];
};

export const reservationPreferenceDeserializer = (currentParamValue: string | null): ReservationPreference | null => {
   return FilterPanel.paramToSingleValue(
      currentParamValue,
      'number',
      (item) =>
         RESERVATION_PREFERENCES.find((preference) => RESERVATION_PREFERENCE_TO_SEARCH_PARAM[preference] === item)!
   );
};
